__turbopack_context__.v({
  "root": "NoDataBlock-module-scss-module__m_aZHa__root",
});
